<template>
  <div v-if="$auth.ready() && $auth.check('admin')">
    <nav role="navigation">
      <breadcrumbs></breadcrumbs>
      <router-view></router-view>
    </nav>
  </div>
</template>
<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
  metaInfo() {
    return {
      title: this.$i18n.t("Administration")
    };
  },
  components: {
    Breadcrumbs
  },
  beforeCreate() {
    if (!this.$auth.ready() || !this.$auth.check("admin")) {
      this.$router.push("/403");
    }
  }
};
</script>
<style lang="stylus">

<style lang="stylus">

button:focus,
input:focus,
select:focus,
textarea:focus,
a:focus {
  outline: 3px solid #f39c12;  /* Couleur personnalisée pour le focus */
  outline-offset: 2px;          /* Espace entre l'élément et le contour */
}
</style>
